<template>
  <div class="ai-visibility-filter-chips">
    <span v-if="label" class="ai-visibility-filter-chips__label">{{ label }}</span>
    <button
      v-for="filter in filters"
      :key="filter.value"
      type="button"
      class="ai-visibility-filter-chips__chip"
      :class="{
        'ai-visibility-filter-chips__chip--active': value === filter.value,
      }"
      :aria-pressed="value === filter.value ? 'true' : 'false'"
      @click="selectFilter(filter.value)"
    >
      {{ filter.label }}
      <span
        v-if="hasCount(filter.value)"
        class="ai-visibility-filter-chips__count"
      >
        {{ counts[filter.value] }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'FilterChips',
  props: {
    value: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    counts: {
      type: Object,
      default () {
        return {}
      },
    },
    label: {
      type: String,
      default: 'Show me:',
    },
  },
  methods: {
    hasCount (filterValue) {
      return Object.prototype.hasOwnProperty.call(this.counts, filterValue)
    },
    selectFilter (nextValue) {
      if (nextValue === this.value) {
        return
      }

      this.$emit('input', nextValue)
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-filter-chips {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.ai-visibility-filter-chips__label {
  color: var(--v-mainColor-base);
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
}

.ai-visibility-filter-chips__chip {
  min-height: 34px;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 20px;
  background: var(--v-cardBg-base);
  color: var(--v-blackColor-base);
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  padding: 6px 10px;
  white-space: nowrap;
}

.ai-visibility-filter-chips__count {
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 400;
  background-color: var(--v-pink1Color-base);
}

.ai-visibility-filter-chips__chip--active {
  border-color: #767B87;
  background: #767B87;
  color: var(--v-whiteColor-base);
}

.ai-visibility-filter-chips__chip--active .ai-visibility-filter-chips__count {
  background-color: var(--v-whiteColor-base);
  color: #767B87;
}

@media (max-width: 480px) {
  .ai-visibility-filter-chips {
    width: 100%;
  }
}
</style>
